// 库存认证 strip — lives on 当日现货, settles the SELECTED day per store so
// plan-vs-actual (备货准确率) has a stable actual. The day's 售出/报废/调拨 are
// logged in the grid above; this only STAMPS the day (writes inventory_days +
// snapshots the store's on-hand close). Driven by 当日现货's own date roll, so
// certifying a past day = roll back to it, then 认证. 店长/管理员 only.
//
// Certify is a re-stampable settle marker, not a hard lock: the grid stays
// editable for backfill/corrections, and 重新认证 re-snapshots after a fix.

import { useEffect, useState } from 'react';
import * as api from '../lib/api.ts';
import { torontoToday } from '../lib/torontoTime.js';
import { Icon } from './Icon.jsx';

const STORES = ['NY', 'DT', 'RH'];

function daysBetween(fromYmd, toYmd) {
  const a = Date.UTC(...fromYmd.split('-').map((n, i) => (i === 1 ? n - 1 : +n)));
  const b = Date.UTC(...toYmd.split('-').map((n, i) => (i === 1 ? n - 1 : +n)));
  return Math.round((b - a) / 86_400_000);
}

export function CertifyStrip({ selectedDate, elevated, onJumpToDate, onToast }) {
  const [cert, setCert] = useState(null);        // /certify?date= → per-store status
  const [pending, setPending] = useState(null);  // /certify/pending → oldest uncertified
  const [busy, setBusy] = useState(null);

  function reload() {
    api.loadCertify(selectedDate).then(setCert).catch(() => setCert(null));
    api.loadCertifyPending().then(setPending).catch(() => setPending(null));
  }
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, [selectedDate]);

  if (!elevated) return null;

  const today = torontoToday();
  const isPast = selectedDate < today;
  const certified = cert?.certified || {};
  const pendingCount = pending?.count || 0;
  const oldestDate = Object.values(pending?.oldestByStore || {}).sort()[0];

  async function certify(store) {
    setBusy(store);
    try {
      const r = await api.certifyStore(selectedDate, store);
      onToast?.({ kind: 'success', msg: `已认证 · ${store} · ${selectedDate} · 收市 ${r.onHandClose ?? '—'}` });
      reload();
    } catch (e) { onToast?.({ kind: 'error', msg: e?.message || '认证失败' }); }
    finally { setBusy(null); }
  }

  return (
    <div className="cert-strip">
      <div className="cert-strip-head">
        <span className="cert-strip-title"><Icon name="check" /> 库存认证 · {selectedDate}{selectedDate === today ? '（今日）' : ''}</span>
        {pendingCount > 0 && oldestDate && oldestDate !== selectedDate && (
          <button className="cert-strip-jump" onClick={() => onJumpToDate?.(oldestDate)}>
            <Icon name="alert" /> 还有 {pendingCount} 天未认证 · 跳到最早（{oldestDate}）
          </button>
        )}
      </div>
      <div className="cert-strip-stores">
        {STORES.map(s => {
          const c = certified[s];
          const overdue = isPast && !c ? daysBetween(selectedDate, today) : 0;
          return (
            <div key={s} className={`cert-chip${c ? ' is-done' : overdue ? ' is-overdue' : ''}`}>
              <span className="cert-chip-store">{s}</span>
              {c ? (
                <span className="cert-chip-status"><Icon name="check" /> 已认证{c.certifiedByName ? ` · ${c.certifiedByName}` : ''} · 收市 {c.onHandClose ?? '—'}</span>
              ) : (
                <span className="cert-chip-status">{overdue > 0 ? <><Icon name="alert" /> 逾期 {overdue} 天</> : '未认证'}</span>
              )}
              {c
                ? <button className="cert-chip-re" disabled={busy === s} onClick={() => certify(s)} title="数据更正后可重新认证">重新认证</button>
                : <button className="btn btn-primary cert-chip-btn" disabled={busy === s} onClick={() => certify(s)}>{busy === s ? '…' : '认证'}</button>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
